<template>
    <v-navigation-drawer v-model="drawer" app width="280px">
        <v-list dense>
            <v-list-item v-for="(item, i) in navItems" :key="i" :to="item.path" :color="kingsGold" link>
                <v-list-item-action>
                    <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>{{ item.label }}</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
export default {
    name: 'student-navigation',
    props: {
        drawer: {
            required: true,
            type: Boolean
        }
    },
    data() {
        return {
            navItems: [{
                    color: '#3699FF',
                    icon: 'mdi-home',
                    label: 'Home',
                    path: '/student'
                },
                {
                    color: '#FFA800',
                    icon: 'mdi-file-document-multiple',
                    label: 'My Applications',
                    path: '/my-applications'
                },
                {
                    color: '#1BC5BD',
                    icon: 'mdi-file-document-edit',
                    label: 'Online Residence Application',
                    path: '/online-residence-application'
                },
                {
                    color: '#F64E60',
                    icon: 'mdi-folder-information',
                    label: 'Release of Information Form',
                    path: '/release-of-information'
                }
            ]
        }
    },
    computed: {
        kingsGold() {
            return '#d7ae28';
        }
    }
}
</script>